var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"100vh"}},[_c('v-row',{staticClass:"align-center",staticStyle:{"height":"100%"},attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-progress-linear',{attrs:{"color":"deep-purple accent-4","indeterminate":"","rounded":"","height":"6"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }